import React from 'react';
import pluralize from 'pluralize';

import styles from './ProfileUncompletedMessage.module.less';

export default function ProfileUncompletedMessage(
  unfilledSections: React.ReactNode[],
) {
  const pluralizedSections = pluralize('section', unfilledSections.length);

  return (
    <div>
      Please update the following {pluralizedSections}:{' '}
      <span className={styles.sectionTitle}>{unfilledSections}</span>
    </div>
  );
}
